import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationsApi } from 'api/btlApplications';

export const useBtlApplications = (): UseQueryResult<any> =>
  useQuery(['btl-applications'], () => btlApplicationsApi.getAll() || null);
